/* Sand House favorites (lists). Guest: localStorage "sh_favorites".
   Shape: {v:2, lists:[{id,name,items:[{handle,added}]}]}; list id "default" = My Favorites (permanent).
   Signed-in: stored per customer id on this device ("sh_favorites_c<id>"); guest lists merge in on login.
   Theme code cannot write to the customer account, so there is no cross-device sync. */
(function(){
  if (window.SHFav) return;
  var KEY='sh_favorites', DEF='default', DEFNAME='My Favorites';
  var acct=document.getElementById('sh-fav-account');
  var cid=acct&&acct.dataset.customerId||'';
  function now(){return Date.now();}
  function uid(){return 'l'+now().toString(36)+Math.random().toString(36).slice(2,6);}
  function norm(d){
    if(Array.isArray(d)){ // migrate old flat array: ["handle"] or [{handle,added}]
      d={lists:[{id:DEF,name:DEFNAME,items:d.map(function(x){return typeof x==='string'?{handle:x,added:now()}:{handle:x.handle,added:x.added||now()};})}]};
    }
    if(!d||!Array.isArray(d.lists)) d={lists:[]};
    d.lists=d.lists.filter(function(l){return l&&l.name;}).map(function(l){
      var seen={};return {id:l.id||uid(),name:String(l.name).slice(0,60),items:(l.items||[]).filter(function(i){if(!i||!i.handle||seen[i.handle])return false;return seen[i.handle]=1;})};});
    var def=d.lists.filter(function(l){return l.id===DEF;})[0];
    if(!def){def={id:DEF,name:DEFNAME,items:[]};}
    d.lists=[def].concat(d.lists.filter(function(l){return l.id!==DEF;}));
    def.name=DEFNAME; d.v=2; return d;
  }
  function parse(s){try{return JSON.parse(s);}catch(e){return null;}}
  function load(){return norm(parse(localStorage.getItem(KEY)));}
  function merge(a,b){ // merge b into a by list name (case-insensitive), dedupe items, keep earliest added
    a=norm(a);b=norm(b);
    b.lists.forEach(function(bl){
      var al=bl.id===DEF?a.lists[0]:a.lists.filter(function(l){return l.name.toLowerCase()===bl.name.toLowerCase();})[0];
      if(!al){al={id:bl.id===DEF?DEF:uid(),name:bl.name,items:[]};a.lists.push(al);}
      bl.items.forEach(function(it){var ex=al.items.filter(function(x){return x.handle===it.handle;})[0];
        if(ex){ex.added=Math.min(ex.added||it.added,it.added||ex.added);} else al.items.push({handle:it.handle,added:it.added||now()});});
    });
    return norm(a);
  }
  // Guests: "sh_favorites". Signed-in: "sh_favorites_c<customerId>" so accounts sharing a device stay separate.
  var GKEY=KEY; if(cid) KEY='sh_favorites_c'+cid;
  var data=load();
  if(Array.isArray(parse(localStorage.getItem(KEY)))) localStorage.setItem(KEY,JSON.stringify(data)); // persist migration of the old flat array
  if(cid){
    // Seed from the account metafield if one ever exists (theme code can read it, not write it).
    var acc=parse(acct.dataset.favorites||''); if(acc) data=merge(data,acc);
    // Merge-on-login: fold guest lists into this customer's lists by list name, dedupe items, then clear the guest copy.
    var guest=parse(localStorage.getItem(GKEY));
    if(guest){ data=merge(data,guest); localStorage.removeItem(GKEY); }
    save(data);
  }
  function save(d){
    data=norm(d); localStorage.setItem(KEY,JSON.stringify(data)); render();
    document.dispatchEvent(new CustomEvent('sh:favorites',{detail:data}));
  }
  function inAny(h){return data.lists.some(function(l){return l.items.some(function(i){return i.handle===h;});});}
  function count(){var s={};data.lists.forEach(function(l){l.items.forEach(function(i){s[i.handle]=1;});});return Object.keys(s).length;}
  function render(){
    document.querySelectorAll('[data-sh-fav]').forEach(function(b){var on=inAny(b.dataset.shFav);b.setAttribute('aria-pressed',on?'true':'false');b.classList.toggle('is-on',on);});
    var n=count();
    document.querySelectorAll('[data-sh-fav-count]').forEach(function(c){c.textContent=n>9?'9+':n;c.hidden=n===0;});
    document.querySelectorAll('[data-sh-fav-link]').forEach(function(a){a.setAttribute('aria-label','Favorites'+(n?', '+n+(n===1?' item':' items'):''));});
  }
  window.addEventListener('storage',function(e){if(e.key===KEY){data=load();render();document.dispatchEvent(new CustomEvent('sh:favorites',{detail:data}));}});

  /* ---------- popover / bottom sheet ---------- */
  var pop,lastBtn,curHandle;
  function el(tag,cls,txt){var e=document.createElement(tag);if(cls)e.className=cls;if(txt!=null)e.textContent=txt;return e;}
  function close(){if(!pop)return;pop.remove();pop=null;document.removeEventListener('keydown',onKey,true);document.removeEventListener('pointerdown',onOut,true);if(lastBtn)lastBtn.focus();}
  function onKey(e){if(e.key==='Escape'){e.preventDefault();close();}
    if(e.key==='Tab'&&pop){var f=pop.querySelectorAll('button,input,a[href]');if(!f.length)return;var a=f[0],z=f[f.length-1];
      if(e.shiftKey&&document.activeElement===a){e.preventDefault();z.focus();}else if(!e.shiftKey&&document.activeElement===z){e.preventDefault();a.focus();}}}
  function onOut(e){if(pop&&!pop.contains(e.target)&&!(lastBtn&&lastBtn.contains(e.target)))close();}
  function place(){
    if(!pop)return; var mobile=window.matchMedia('(max-width:749px)').matches;
    pop.classList.toggle('sh-favpop--sheet',mobile);
    if(mobile){pop.style.left=pop.style.top='';return;}
    var r=lastBtn.getBoundingClientRect(),w=pop.offsetWidth,h=pop.offsetHeight;
    var left=Math.min(Math.max(8,r.right-w),innerWidth-w-8), top=r.bottom+6;
    if(top+h>innerHeight-8) top=Math.max(8,r.top-h-6);
    pop.style.left=left+'px';pop.style.top=top+'px';
  }
  function shell(title){
    close(); pop=el('div','sh-favpop'); pop.setAttribute('role','dialog'); pop.setAttribute('aria-modal','false');
    var id='shfp'+now(); var h=el('p','sh-favpop__title',title); h.id=id; pop.setAttribute('aria-labelledby',id);
    var x=el('button','sh-favpop__close'); x.type='button'; x.setAttribute('aria-label','Close'); x.innerHTML='&times;'; x.onclick=close;
    pop.appendChild(x); pop.appendChild(h); document.body.appendChild(pop);
    document.addEventListener('keydown',onKey,true); setTimeout(function(){document.addEventListener('pointerdown',onOut,true);},0);
    return pop;
  }
  function signinPrompt(){
    var p=shell('Sign in to save your favorites to your account');
    p.appendChild(el('p','sh-favpop__text','Your lists stay with your account on this device.'));
    var row=el('div','sh-favpop__actions');
    var a=el('a','sh-favpop__btn sh-favpop__btn--solid','Sign in');
    a.href='/account/login?return_url='+encodeURIComponent(location.pathname+location.search);
    var g=el('button','sh-favpop__btn sh-favpop__btn--ghost','Continue as guest'); g.type='button';
    g.onclick=function(){sessionStorage.setItem('sh_fav_prompted','1');saveTo();};
    a.addEventListener('click',function(){sessionStorage.setItem('sh_fav_prompted','1');});
    row.appendChild(a);row.appendChild(g);p.appendChild(row);place();a.focus();
  }
  function saveTo(){
    var h=curHandle, p=shell('Save to'), ul=el('ul','sh-favpop__lists');
    data.lists.forEach(function(l){
      var li=el('li'),lab=el('label','sh-favpop__opt'),cb=el('input');cb.type='checkbox';
      cb.checked=l.items.some(function(i){return i.handle===h;});
      cb.onchange=function(){var d=data,L=d.lists.filter(function(x){return x.id===l.id;})[0];if(!L)return;
        if(cb.checked){if(!L.items.some(function(i){return i.handle===h;}))L.items.push({handle:h,added:now()});}
        else L.items=L.items.filter(function(i){return i.handle!==h;});
        save(d); status.textContent=cb.checked?'Saved to '+l.name+'.':'Removed from '+l.name+'.';};
      lab.appendChild(cb);lab.appendChild(el('span',null,l.name));li.appendChild(lab);ul.appendChild(li);
    });
    p.appendChild(ul);
    var f=el('form','sh-favpop__new'),lab=el('label','visually-hidden','New list name'),inp=el('input'),b=el('button','sh-favpop__add','+ Create new list');
    inp.id='shfpnew';lab.htmlFor='shfpnew';inp.placeholder='New list name';inp.maxLength=60;inp.autocomplete='off';b.type='submit';
    f.onsubmit=function(e){e.preventDefault();var n=inp.value.trim();if(!n)return inp.focus();
      var d=data,ex=d.lists.filter(function(l){return l.name.toLowerCase()===n.toLowerCase();})[0];
      if(!ex){ex={id:uid(),name:n,items:[]};d.lists.push(ex);}
      if(!ex.items.some(function(i){return i.handle===h;}))ex.items.push({handle:h,added:now()});
      save(d);saveTo();pop.querySelector('[role=status]').textContent='Saved to '+ex.name+'.';};
    f.appendChild(lab);f.appendChild(inp);f.appendChild(b);p.appendChild(f);
    var status=el('p','sh-favpop__status');status.setAttribute('role','status');p.appendChild(status);
    var link=el('a','sh-favpop__link','View favorites');link.href='/pages/favorites';p.appendChild(link);
    place();(p.querySelector('input[type=checkbox]')||inp).focus();
  }
  function open(btn){
    lastBtn=btn;curHandle=btn.dataset.shFav;
    if(!cid&&count()>0&&!sessionStorage.getItem('sh_fav_prompted')){sessionStorage.setItem('sh_fav_prompted','1');return signinPrompt();}
    saveTo();
  }
  document.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('[data-sh-fav]'); if(!b)return;
    e.preventDefault();e.stopPropagation();
    if(pop&&lastBtn===b){close();return;} open(b);
  },true);
  window.addEventListener('resize',place);
  window.addEventListener('scroll',function(){if(pop&&!pop.classList.contains('sh-favpop--sheet'))place();},{passive:true});

  /* ---------- product page heart (inserted next to the title) ---------- */
  function heartHTML(h,title){return '<button type="button" class="sh-fav-btn" data-sh-fav="'+h+'" aria-pressed="false" aria-label="Save '+title.replace(/"/g,'&quot;')+' to favorites"><svg class="sh-fav-ico" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.3l-1.2-1.1C6.4 15.3 3.5 12.6 3.5 9.3 3.5 6.7 5.5 4.7 8.1 4.7c1.5 0 2.9.7 3.9 1.8 1-1.1 2.4-1.8 3.9-1.8 2.6 0 4.6 2 4.6 4.6 0 3.3-2.9 6-7.3 9.9L12 20.3z"/></svg></button>';}
  function productHeart(){
    var m=location.pathname.match(/\/products\/([^\/?#]+)/); if(!m)return;
    var t=document.querySelector('.product__title, .product__block--title h1, h1.product__title, [data-product-title]')||document.querySelector('main h1');
    if(!t||document.querySelector('.sh-fav-btn--pdp'))return;
    var wrap=document.createElement('div');wrap.className='sh-fav-pdp';t.parentNode.insertBefore(wrap,t);wrap.appendChild(t);
    wrap.insertAdjacentHTML('beforeend',heartHTML(decodeURIComponent(m[1]),t.textContent.trim()));
    wrap.lastElementChild.classList.add('sh-fav-btn--pdp');
  }

  window.SHFav={get:function(){return data;},save:save,merge:merge,norm:norm,inAny:inAny,count:count,render:render,heartHTML:heartHTML,DEF:DEF,customerId:cid};
  function init(){productHeart();render();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  // re-render when grids re-render (filters, infinite scroll, quick view)
  var rq;new MutationObserver(function(ms){for(var i=0;i<ms.length;i++){var a=ms[i].addedNodes;for(var j=0;j<a.length;j++){var n=a[j];if(n.nodeType===1&&(n.matches('[data-sh-fav]')||n.querySelector('[data-sh-fav]'))){if(!rq)rq=requestAnimationFrame(function(){rq=0;render();});return;}}}}).observe(document.documentElement,{childList:true,subtree:true});
})();
